import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  createAuthorizationHeader,
  throwIfNotOk,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { Comment, CreateComment } from "../types/Comment";

const BASE_URL = `${TASKS_SERVICE_URL}/comments`;

export async function createComment(createComment: CreateComment) {
  return toJson<Comment>(
    await fetch(BASE_URL, {
      method: "POST",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createComment),
    })
  );
}

export async function updateComment(
  commentId: string,
  updates: Partial<Pick<CreateComment, "text" | "images">>
) {
  return toJson<Comment>(
    await fetch(`${BASE_URL}/${commentId}`, {
      method: "PUT",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
    })
  );
}

export async function deleteComment(commentId: string) {
  return throwIfNotOk(
    await fetch(`${BASE_URL}/${commentId}`, {
      method: "DELETE",
      headers: {
        ...(await createAuthorizationHeader()),
      },
    })
  );
}
